<template>
  <BaseModal ref="base" name="enviarEmailCodigosModal" centered>
    <template #title>
      Enviar email
    </template>
    <template #body>
      Deseja enviar email com os códigos para o parceiro <b class="text-break">{{ nome }}</b>?
    </template>
    <template #footer>
      <LoadingButton type="button" class="btn-primary" :loading="loading" @click="enviar">
        <i class="bi bi-send" /> Enviar
      </LoadingButton>
      <button type="button" class="btn btn-secondary" @click="hide">
        <i class="bi bi-x" /> Cancelar
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/modules/core/components/BaseModal.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { useToast } from 'vue-toastification';
import { enviarEmailCodigos } from '../parceiroService';

export default {
  components: { BaseModal, LoadingButton },
  props: {
    id: { type: String, required: true },
    nome: { type: String, required: true },
  },
  data: () => ({ loading: false }),
  methods: {
    show() { this.$refs.base.show(); },
    hide() { this.$refs.base.hide(); },
    async enviar() {
      this.loading = true;
      try {
        if (await enviarEmailCodigos(this.id)) {
          useToast().success(`Email enviado para o parceiro '${this.nome}'.`);
        } else {
          useToast().warning(`O parceiro '${this.nome}', não possui código disponível.`);
        }
        this.$refs.base.hide();
      } catch (error) {
        useToast().error('Erro de conexão');
      }
      this.loading = false;
    },
  },
};
</script>
